import type { RequestDTO } from '@core/types';
import { RequestProducts } from '@core/types/Product';
import {
  PRIMARY_DOCUMENTATION,
  type NullablePrimaryDocumentation,
} from '@outkeep/shared';

export function isPrimaryDocumentationRequired(
  requests: ReadonlyArray<Pick<RequestDTO, 'products'> | null | undefined>,
): boolean {
  return requests.some(request =>
    request?.products?.some(
      product =>
        product.requestProductId.id === RequestProducts.LSAcceptanceAndTransfer,
    ),
  );
}

export function getPrimaryDocumentationTranslationKey(
  value: NullablePrimaryDocumentation,
): string {
  switch (value) {
    case PRIMARY_DOCUMENTATION.EDO:
      return 'request_form.deal_details.primary_documentation_edo';
    case PRIMARY_DOCUMENTATION.PAPER:
      return 'request_form.deal_details.primary_documentation_paper';
    case PRIMARY_DOCUMENTATION.ABSENT:
      return 'request_form.deal_details.primary_documentation_absent';
    default:
      return 'request_form.deal_details.primary_documentation_not_filled';
  }
}
